/* eslint-disable
    no-unused-vars,
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import PropTypes from 'prop-types';
import _ from 'underscore';

import ProtocolEditor from 'notebook/protocols/editor/Editor';
import HistoryManager from 'notebook/store/HistoryManager';
import DocumentManagerComponent from 'notebook/mediocre/core-ui/DocumentManagerComponent';

class ProtocolViewComponent extends React.Component {
  static propTypes = {
    banner: PropTypes.string,
    fileId: PropTypes.string.isRequired,
    onSaving: PropTypes.func,
    onRetrying: PropTypes.func,
    onSaved: PropTypes.func,
    locked: PropTypes.bool.isRequired,
    printHandler: PropTypes.func,
    printOptions: PropTypes.array,
    openManageSelectorsModal: PropTypes.func.isRequired,
    historyManager: PropTypes.instanceOf(HistoryManager),
    spellCheck: PropTypes.bool.isRequired,
    printLayout: PropTypes.bool.isRequired,
    showPrintMargins: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    if (this.props.protocol != null) {
      if (typeof this.props.onLoad === 'function') {
        this.props.onLoad();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {saving} = this.props;
    const unsaved = this.props.savedVersion !== this.props.openVersion;
    const noError = this.props.saveSuccess;
    if (saving || unsaved) {
      if (noError) {
        if (typeof this.props.onSaving === 'function') {
          this.props.onSaving();
        }
      } else if (typeof this.props.onRetrying === 'function') {
        this.props.onRetrying();
      }
    } else if (typeof this.props.onSaved === 'function') {
      this.props.onSaved();
    }

    if (this.props.protocol != null && prevProps.protocol == null) {
      if (typeof this.props.onLoad === 'function') {
        this.props.onLoad();
      }
    }
  }

  render() {
    if (this.props.protocol == null) {
      return <div>Loading...</div>;
    }
    return (
      <div className="protocol-view-component">
        <DocumentManagerComponent
          currentVersion={this.props.protocol}
          historyManager={this.props.historyManager}
          restoreStateAndSelection={this.props.revertProtocol}
          renderWith={({metadataForRestore, storeState, restoreState, requestSelection, undoStoreState}) => (
            <ProtocolEditor
              banner={this.props.banner}
              fileId={this.props.fileId}
              protocol={this.props.protocol}
              printHandler={this.props.printHandler}
              showToolbar={true}
              locked={this.props.locked}
              moreFormats={this.props.moreFormats}
              printOptions={this.props.printOptions}
              updateProtocol={!this.props.locked ? this.props.updateProtocol : undefined}
              revertProtocol={!this.props.locked ? this.props.revertProtocol : undefined}
              openManageSelectorsModal={this.props.openManageSelectorsModal}
              displayOptions={this.props.displayOptions}
              spellCheck={this.props.spellCheck}
              printLayout={this.props.printLayout}
              showPrintMargins={this.props.showPrintMargins}
              // For selections
              metadataForRestore={metadataForRestore}
              storeState={storeState}
              undoStoreState={undoStoreState}
              restoreState={restoreState}
              requestSelection={requestSelection}
            />
          )}
        />
      </div>
    );
  }
}

export default ProtocolViewComponent;
